module.exports = __webpack_public_path__ + "static/media/am-download.0fd113e6.svg";